import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React from "react";
import { Link, useLocation } from "react-router-dom";

interface AllShopItemProps {}

const AllShopItem: React.FC<AllShopItemProps> = function (props) {
    const location = useLocation();

    const active = location.pathname.startsWith("/order/list/allShop");

    return (
        <Link
            className={classNames("nav-link", {
                active,
            })}
            to={{
                pathname: "/order/list/allShop",
            }}
        >
            <span>全部订单</span>
            <span className="text-muted small">(跨店铺)</span>
        </Link>
    );
};

export default observer(AllShopItem);
